import { Api } from "@core/api/api";
import { pageParams, transactionFilterParams } from "@core/api/pageParams";
import { Page, PaginationOptions } from "@utils/page";
import { disbursementFromDto, disbursementToDto, WalletDto, walletFromDto, WalletFromDto, walletToDto } from "./dto";
import { AllWallet, Cashable, Disbursement, Earning, TransactionFilterOptions, Wallet } from "./wallet";
import { DisbursementDraft, WalletDraft } from "./walletDraft";

const WALLET_URL = "/payment_services/merchant_payment";
const CORE_URL = "/groups";
const CASHOUT = "/transactions";

export class WalletApi {
	constructor(private readonly api: Api) {}

	async getWallet(): Promise<Array<AllWallet>> {
		const result = await this.api.get<Promise<Array<AllWallet>>>(`${WALLET_URL}`);
		return result.data;
	}
	async create(draft: WalletDraft, groupId: string): Promise<Wallet> {
		const result = await this.api.post<WalletFromDto>(`${CORE_URL}/${groupId}/subscription`, walletToDto(draft));
		return walletFromDto(result.data);
	}

	async getEarning(groupId: string): Promise<Earning> {
		const result = await this.api.get<Promise<Earning>>(`${CORE_URL}/${groupId}/earnings`);
		return result.data;
	}

	async getCashable(groupId: string): Promise<Cashable> {
		const result = await this.api.get<Promise<Cashable>>(`${CORE_URL}/${groupId}/cashable`);
		return result.data;
	}

	async getTransactionHistorique(id: string | undefined): Promise<Wallet> {
		const result = await this.api.get<WalletDto>(`${CORE_URL}?transactionId=${id}`);
		return walletFromDto(result.data);
	}

	async getTransactionById(paymentId: string): Promise<WalletDto> {
		const result = await this.api.get<WalletDto>(`${CORE_URL}/payments?${paymentId}`);
		return result.data;
	}

	async listTransactions(
		filterOptions: TransactionFilterOptions | undefined,
		pageOptions: PaginationOptions,
		groupId: string
	): Promise<Page<Wallet>> {
		const result = await this.api.get<Page<WalletDto>>(
			`${CORE_URL}/${groupId}/transactions-in-period?${pageParams(pageOptions)}${transactionFilterParams(
				filterOptions
			)}`
		);

		return { ...result.data, content: result.data.content.map(walletFromDto) };
	}

	// async listDisbursements(
	// 	groupId: string,
	// 	pageOptions: PaginationOptions,
	// ): Promise<Page<Disbursement>> {
	// 	const result = await this.api.get<Page<DisbursementDto>>(
	// 		`${CORE_URL}/${groupId}/balances-mensuelles2?${pageParams(pageOptions)}`
	// 	);
	// 	// console.log("result", result.data.content.map(disbursementFromDto))
	// 	return { ...result.data, content: result.data.content.map(disbursementFromDto) };
	// }

	async listDisbursements(groupId: string): Promise<Array<Disbursement>> {
		const result = await this.api.get<Promise<Array<Disbursement>>>(`${CORE_URL}/${groupId}/monthly-balances-list`);
		return result.data;
	}

	async cashout(draft: DisbursementDraft, groupId: string): Promise<Disbursement> {
		const result = await this.api.post<Disbursement>(
			`${CASHOUT}/disbursements/${groupId}/monthlies`,
			disbursementToDto(draft)
		);
		return disbursementFromDto(result.data);
	}
}
